(function (g) {
  'use strict';
  if (g.CarbonInitials) return;
  const selector = 'input[name=initials],input[name=employee_initials],input[name=editorInitials],input[name=actor],input[name=actorLabel],input[data-dw-initials],input[data-ps-actor]';
  let current = null, bridging = false, restoring = false, activation = null;
  const style = document.createElement('style');
  style.dataset.carbonInitials = 'v1';
  style.textContent = `
    .cc-initials-prompt{box-sizing:border-box;width:min(360px,calc(100vw - 32px));max-height:calc(100dvh - 32px);overflow:auto;margin:auto;padding:26px;background:#17241b;color:#f0f0df;border:1px solid #a7aa75;border-radius:16px;box-shadow:0 24px 90px #000b;font:15px/1.4 system-ui;text-align:center}
    .cc-initials-prompt::backdrop,.cc-initials-session::backdrop{background:radial-gradient(ellipse at center,#07100955 0%,#030805c9 75%);backdrop-filter:blur(5px);-webkit-backdrop-filter:blur(5px)}
    .cc-initials-prompt h2{font:700 23px/1.2 system-ui;color:#f0f0df;letter-spacing:normal;text-transform:none;margin:0 0 8px}
    .cc-initials-prompt p{font:14px/1.4 system-ui;color:#c5cebb;margin:0 0 18px}
    .cc-initials-prompt label{display:block;font:600 13px/1.4 system-ui;color:#d7c584}
    .cc-initials-prompt input{display:block;box-sizing:border-box;width:160px;max-width:100%;height:64px;margin:8px auto 4px;padding:8px 12px;border:2px solid #d7c584;border-radius:10px;background:#0b150e;color:#fff;font:750 30px/1 system-ui;letter-spacing:.12em;text-align:center;text-transform:uppercase;box-shadow:0 0 0 5px #d7c58418}
    .cc-initials-prompt input:focus-visible{outline:2px solid #f0df9b;outline-offset:4px}
    .cc-initials-prompt small{display:block;min-height:18px;margin:9px 0 14px;color:#c5cebb;font:12px/1.4 system-ui}
    .cc-initials-prompt footer{display:flex;justify-content:center;gap:10px}
    .cc-initials-prompt button{min-height:38px;padding:8px 16px;border:1px solid #788766;border-radius:7px;background:#2c3c2c;color:#f0f0df;font:650 14px/1.3 system-ui;cursor:pointer}
    .cc-initials-prompt button[type=submit]{background:#d7c584;border-color:#d7c584;color:#172214}
    .cc-initials-prompt button:hover{filter:brightness(1.12)}
    .cc-initials-prompt button:focus-visible{outline:2px solid #f0df9b;outline-offset:3px}
    .cc-initials-nudge{animation:cc-initials-nudge 430ms ease-out}
    @keyframes cc-initials-nudge{0%,100%{transform:translateX(0) scale(1)}25%{transform:translateX(-5px) scale(1.1)}45%{transform:translateX(5px) scale(1.1)}65%{transform:translateX(-3px) scale(1.05)}82%{transform:translateX(2px) scale(1.02)}}
    @media(prefers-reduced-motion:reduce){.cc-initials-nudge{animation:cc-initials-glow 250ms ease-out}@keyframes cc-initials-glow{50%{outline:3px solid #f0df9b;outline-offset:4px}}}
  `;
  document.head.append(style);
  const eligible = el => el?.matches?.(selector) && !el.disabled && !el.readOnly && !el.closest('.cc-initials-prompt');
  const missing = el => eligible(el) && (!el.value.trim() || (el.pattern && !el.validity.valid));
  function nudge(input) {
    input.classList.remove('cc-initials-nudge');
    void input.offsetWidth;
    input.classList.add('cc-initials-nudge');
    input.focus({ preventScroll: true });
  }
  function request(options = {}) {
    if (current) { nudge(current.input); return Promise.resolve(null); }
    const source = options.input, owner = options.owner || source?.closest('form,dialog') || source;
    if (source && !source.isConnected) return Promise.resolve(null);
    const dialog = document.createElement('dialog');
    dialog.className = 'cc-initials-prompt';
    dialog.setAttribute('aria-labelledby', 'cc-initials-title');
    dialog.setAttribute('aria-describedby', 'cc-initials-context');
    dialog.innerHTML = '<form novalidate><h2 id="cc-initials-title">Your initials</h2><p id="cc-initials-context"></p><label>Initials<input name="carbonInitials" autocomplete="off" autocapitalize="characters" spellcheck="false" required aria-describedby="cc-initials-help"></label><small id="cc-initials-help" role="status"></small><footer><button type="button">Cancel</button><button type="submit">Continue</button></footer></form>';
    const input = dialog.querySelector('input'), form = dialog.querySelector('form'), hint = dialog.querySelector('small');
    // Retain stricter contracts such as Studio's 2–4 letter editing identity.
    input.maxLength = source?.maxLength > 0 ? source.maxLength : 5;
    input.pattern = source?.pattern || (input.maxLength <= 5 ? '[A-Za-z]{2,' + input.maxLength + '}' : '[A-Za-z][A-Za-z .-]*');
    input.minLength = source?.minLength > 0 ? source.minLength : 2;
    input.value = source?.value || options.value || '';
    const help = input.maxLength <= 5 ? 'Use 2–' + input.maxLength + ' letters.' : 'Enter your initials to continue.';
    hint.textContent = help;
    dialog.querySelector('p').textContent = options.context || 'Add your initials to continue.';
    let resolve;
    const promise = new Promise(done => { resolve = done; });
    const previous = document.activeElement;
    const state = current = { dialog, input, source, owner, finish };
    function finish(value) {
      if (current !== state) return;
      observer.disconnect();
      // Notify the original form while its prompt still holds the refresh guard.
      if (value && source?.isConnected) {
        source.value = value;
        source.dispatchEvent(new Event('input', { bubbles: true }));
        source.dispatchEvent(new Event('change', { bubbles: true }));
      }
      current = null;
      restoring = true;
      dialog.close();
      dialog.remove();
      const target = source?.isConnected ? source : previous?.isConnected ? previous : null;
      target?.focus?.({ preventScroll: true });
      queueMicrotask(() => { restoring = false; });
      resolve(value);
    }
    const observer = new MutationObserver(() => {
      if (owner && !owner.isConnected) finish(null);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    form.addEventListener('submit', e => {
      e.preventDefault(); e.stopPropagation();
      input.value = input.value.trim().toUpperCase();
      if (!input.value || !input.validity.valid || input.value.length < input.minLength) {
        hint.textContent = help; nudge(input); return;
      }
      finish(input.value);
    });
    input.addEventListener('input', () => { hint.textContent = help; });
    dialog.querySelector('button[type=button]').onclick = () => finish(null);
    dialog.addEventListener('cancel', e => { e.preventDefault(); e.stopPropagation(); finish(null); });
    dialog.addEventListener('keydown', e => {
      // Do not let the underlying invoice/dialog consume Escape or shortcuts.
      e.stopPropagation();
      if (e.key === 'Escape') { e.preventDefault(); finish(null); }
    });
    dialog.addEventListener('click', e => {
      e.stopPropagation();
      if (e.target !== input && !e.target.closest('button')) nudge(input);
    });
    document.body.append(dialog);
    dialog.showModal();
    nudge(input);
    return promise;
  }
  function bridge(input, trigger = null) {
    if (current || bridging || restoring || !missing(input)) return;
    bridging = true;
    const form = input.form, owner = form || input.closest('dialog') || input;
    queueMicrotask(async () => {
      try {
        const value = await request({ input, owner });
        if (!value || !owner.isConnected || !input.isConnected) return;
        // Replay the original control, including Review/Save & next, exactly once.
        if (trigger?.isConnected && !trigger.disabled) trigger.click();
        else if (trigger === null) return; // Directly editing initials is not a save.
        else if (form?.isConnected) form.requestSubmit();
      } finally { bridging = false; }
    });
  }
  document.addEventListener('click', e => {
    if (current || e.target.closest?.('.cc-initials-prompt')) return;
    activation = e.target.closest?.('button,input[type=submit]');
    const captured = activation;
    queueMicrotask(() => { if (activation === captured) activation = null; });
  }, true);
  document.addEventListener('invalid', e => {
    if (!missing(e.target)) return;
    e.preventDefault();
    if (e.target.name === 'editorInitials' && e.target.closest('dialog[open]')) { nudge(e.target); return; }
    const input = e.target, trigger = activation;
    bridge(input, trigger && (trigger.form === input.form || input.closest('dialog')?.contains(trigger)) ? trigger : false);
  }, true);
  document.addEventListener('submit', e => {
    if (e.target.closest?.('.cc-initials-prompt')) return;
    const input = [...e.target.querySelectorAll(selector)].find(el => el.required && missing(el));
    if (!input) return;
    e.preventDefault(); e.stopImmediatePropagation();
    bridge(input, e.submitter || false);
  }, true);
  document.addEventListener('focusin', e => {
    if (current || restoring || !missing(e.target)) return;
    // Studio already has a dedicated identity dialog; give it the same treatment.
    if (e.target.name === 'editorInitials') {
      const dialog = e.target.closest('dialog');
      dialog?.classList.add('cc-initials-session');
      if (dialog && !dialog.dataset.initialsAttention) {
        dialog.dataset.initialsAttention = 'true';
        dialog.addEventListener('click', event => {
          if (dialog.open && event.target !== e.target && !event.target.closest('button')) nudge(e.target);
        });
      }
      nudge(e.target);
      return;
    }
    bridge(e.target, activation || null);
  });
  g.CarbonInitials = {
    request,
    active: owner => !!current && (!owner || current.owner === owner || owner.contains(current.source)),
    cancel: owner => { if (current && (!owner || current.owner === owner || owner.contains(current.source))) current.finish(null); }
  };
})(window);
